export function parseName(addresses = "") {
	let files = addresses.split(",").map(address => {
		let lastIndex = address.lastIndexOf("/");
		let name = address.substring(lastIndex + 1);
		return {
			name: name,
			url: address
		};
	});
	return files;
}

export function checkRole(currentUserId = "", creatUserId = "") {
	let roleName = window.sessionStorage.getItem("roleName");
	let userId = window.sessionStorage.getItem("userId");
	if (currentUserId === userId) {
		return "all";
	} else {
		if (roleName) {
			return "teacher";
		} else {
			return "student";
		}
	}
}

export function filterUser(a = [], b = []) {
	if (a.length) {
		let filteredB = [];
		for (let i = 0; i < b.length; i++) {
			const bObject = b[i];
			const bObjectId = bObject.id;

			// 检查bObject的id是否已存在于数组a中
			const isIdExists = a.some(aObject => aObject.id === bObjectId);

			if (!isIdExists) {
				filteredB.push(bObject);
			}
		}
		return filteredB;
	} else {
		return b;
	}
}

export function downloadUrl(path, name) {
	let { origin } = window.location;
	const url = `${origin}${path}`;
	const xhr = new XMLHttpRequest();
	xhr.open("GET", url, true); // 也可以使用POST方式，根据接口
	// xhr.setRequestHeader("token", sessionStorage.getItem("token")); // 设置token
	xhr.setRequestHeader("Content-Type", "application/octet-stream");
	xhr.responseType = "blob"; // 返回类型blob
	xhr.onload = function(e) {
		if (this.status === 200) {
			const blob = this.response;
			const reader = new FileReader();
			reader.readAsDataURL(blob); // 转换为base64，可以直接放入a表情href
			reader.onload = function(e) {
				const a = document.createElement("a");
				a.download = name;
				a.href = e.target.result;
				document.documentElement.appendChild(a);
				a.click();
				a.remove(); // 等价于document.documentElement.removeChild(a);
			};
		}
	};
	xhr.send(); // 发送ajax请求
}

export function hasEqualValue(arr1, arr2) {
	for (let i = 0; i < arr1.length; i++) {
		for (let j = 0; j < arr2.length; j++) {
			if (arr1[i] === arr2[j]) {
				return true;
			}
		}
	}
	return false;
}



// WEBPACK FOOTER //
// ./src/common/utils.js